import { useEffect } from 'react';

import { toast } from '@hivebrite/design-system/Toast';

import { type Event } from 'hb-react/shared/apps/Events';

interface UseZoomPageErrorHandlingParams {
  event: Event | undefined;
  isLoadingEvent: boolean;
  isUserAllowedToJoin: boolean;
}

export const useZoomPageErrorHandling = ({
  event,
  isUserAllowedToJoin,
  isLoadingEvent,
}: UseZoomPageErrorHandlingParams) => {
  useEffect(() => {
    // Don't show errors while loading or if user is allowed
    if (isLoadingEvent || isUserAllowedToJoin) {
      return;
    }

    // Show specific error for internal zoom meetings
    if (event?.is_internal_zoom_meeting) {
      toast.error(s__('Zoom|You are not allowed to join at this time.'));

      return;
    }

    // Show generic error for other cases
    toast.error(__('Sorry, an error occurred'));
  }, [event, isUserAllowedToJoin, isLoadingEvent]);
};
